// React
import React from "react";

// Preferences
import {
  useLoadingPreferences,
  setLoadingPref,
} from "../../utils/loadingPreferences";

// Internal Components
import Header from "../../components/layouts/Header/Header";
import TestFooter from "../../components/layouts/Footer/TestFooter";
import SEO from "../../components/seo/SEO";

// Stylesheet
import "./profile.css";

/* Both switches read the same way: on means "show me the tile". The copy says
   what is lost as well as what is gained, because turning both off is a
   reasonable thing to want and should not feel like a warning. */
const PREFERENCES = [
  {
    field: "quotes",
    label: "Quotes",
    hint: "A line from someone worth reading while the page loads.",
  },
  {
    field: "memories",
    label: "Memories",
    hint: "Something you wrote on an earlier day, brought back while the page loads.",
  },
];

export default function ProfilePreferencesScreen() {
  const prefs = useLoadingPreferences();
  const allOff = !prefs.quotes && !prefs.memories;

  return (
    <>
      <SEO
        title="Preferences"
        description="Choose what you see while your pages load on NoWastedDays."
        canonicalUrl={"https://nowasteddays.io/my-account/preferences"}
      />
      <Header variant="light" />
      <main className="mainProfileScreen">
        <div className="data-control-container">
          <h1 className="page-title">Preferences</h1>

          <div className="control-card">
            <h2 className="card-title">While a page loads</h2>
            <p className="body-text">
              Your pages pause for a moment on something worth reading — a
              quote, or one of your own entries from an earlier day. If you'd
              rather just get to the page, turn either of them off here, or
              straight from the tile itself when one appears.
            </p>

            <ul className="pref-list">
              {PREFERENCES.map(({ field, label, hint }) => {
                const enabled = prefs[field];
                const labelId = `pref-${field}-label`;
                return (
                  <li className="pref-row" key={field}>
                    <div className="pref-row__text">
                      <h3 className="pref-row__name" id={labelId}>
                        {label}
                      </h3>
                      <p className="pref-row__hint">{hint}</p>
                    </div>
                    {/* role="switch" with a word beside it: the state is never
                        carried by colour alone (design.md §11). */}
                    <button
                      type="button"
                      role="switch"
                      aria-checked={enabled}
                      aria-labelledby={labelId}
                      className="pref-switch"
                      onClick={() => setLoadingPref(field, !enabled)}
                    >
                      <span className="pref-switch__state">
                        {enabled ? "On" : "Off"}
                      </span>
                      <span className="pref-switch__track" aria-hidden="true">
                        <span className="pref-switch__knob" />
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>

            <p className="pref-note" role="status">
              {allOff
                ? "Both are off. Pages will show a plain loader for as long as the data takes and no longer. You'll still get the celebrations when you hit a milestone."
                : "Saved on this device, so clearing your browser data will turn them back on."}
            </p>
          </div>
        </div>
      </main>
      <TestFooter />
    </>
  );
}
